import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div>
      <header style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid var(--border)',
      }}>
        <div className="container" style={{
          height: '68px', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{
              width: '32px', height: '32px',
              background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)',
              borderRadius: '9px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: 'white', fontSize: '16px', fontWeight: 700,
            }}>a</span>
            <span style={{ fontSize: '22px', fontWeight: 800, color: 'var(--primary)', letterSpacing: '-0.6px' }}>almenu</span>
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Link to="/login" className="btn">Sign in</Link>
            <Link to="/register" className="btn btn-primary">Start free</Link>
          </div>
        </div>
      </header>

      <section style={{ padding: '80px 0 60px', position: 'relative', overflow: 'hidden' }}>
        <div className="container" style={{ textAlign: 'center', maxWidth: '720px' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: 'var(--primary-50)', color: 'var(--primary)',
            fontSize: '13px', fontWeight: 600,
            padding: '6px 14px', borderRadius: '999px', marginBottom: '24px',
          }}>
            New: AI menu conversion in 2 minutes
          </div>
          <h1 style={{
            fontSize: '56px', fontWeight: 800,
            letterSpacing: '-1.5px', lineHeight: 1.05, marginBottom: '20px',
          }}>
            The digital menu{' '}
            <span style={{
              background: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}>
              your restaurant deserves
            </span>
          </h1>
          <p style={{
            fontSize: '18px', color: 'var(--text-2)',
            lineHeight: 1.6, marginBottom: '28px',
            maxWidth: '560px', marginLeft: 'auto', marginRight: 'auto',
          }}>
            Turn your existing PDF menu into a beautiful, interactive QR menu.
            AI does the work — your customers love the experience.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
            <Link to="/register" className="btn btn-primary btn-lg">Start free</Link>
            <Link to="/how-to" className="btn btn-lg">Learn more</Link>
          </div>
        </div>
      </section>

      <section style={{ padding: '60px 0', background: 'var(--bg)', borderTop: '1px solid var(--border)' }}>
        <div className="container" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 160px), 1fr))',
          gap: '24px', textAlign: 'center',
        }}>
          {[
            { num: '6,900+', label: 'Active restaurants' },
            { num: '418K', label: 'QR scans' },
            { num: '141', label: 'Countries' },
            { num: '4.8', label: 'Customer rating' },
          ].map(s => (
            <div key={s.label}>
              <div style={{
                fontSize: '36px', fontWeight: 800,
                background: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
                WebkitBackgroundClip: 'text',
                backgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '4px',
              }}>{s.num}</div>
              <div style={{ fontSize: '13px', color: 'var(--text-2)' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* AI Showcase Section */}
      <section style={{ padding: '80px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              fontSize: '13px', fontWeight: 700, color: 'var(--primary)',
              textTransform: 'uppercase', letterSpacing: '1px',
              marginBottom: '12px',
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3l1.91 5.26L19 10l-5.09 1.74L12 17l-1.91-5.26L5 10l5.09-1.74L12 3z" />
                <path d="M19 17l.95 2.63L22 20l-2.05.37L19 23l-.95-2.63L16 20l2.05-.37L19 17z" />
              </svg>
              Powered by AI
            </div>
            <h2 style={{
              fontSize: '42px', fontWeight: 800,
              letterSpacing: '-1px', lineHeight: 1.15,
              marginBottom: '12px',
              maxWidth: '700px', margin: '0 auto 12px',
            }}>
              Upload your PDF. Get a smart menu in minutes.
            </h2>
            <p style={{
              fontSize: '17px', color: 'var(--text-2)',
              maxWidth: '580px', margin: '0 auto', lineHeight: 1.6,
            }}>
              Stop rebuilding what you already have. Our AI converts your PDF menu into a fully searchable, multi-language digital menu.
            </p>
          </div>

          {/* Dark showcase card */}
          <div style={{
            background: 'linear-gradient(135deg, #0F172A 0%, #4C1D95 50%, #6D28D9 100%)',
            borderRadius: '24px',
            padding: '56px 40px',
            position: 'relative',
            overflow: 'hidden',
            color: 'white',
          }}>
            {/* Decorative glow */}
            <div style={{
              position: 'absolute',
              top: '-100px', right: '-100px',
              width: '400px', height: '400px',
              background: 'radial-gradient(circle, rgba(167, 139, 250, 0.3) 0%, transparent 70%)',
              pointerEvents: 'none',
            }} />

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))',
              gap: '40px',
              alignItems: 'center',
              position: 'relative', zIndex: 2,
            }}>
              {/* Left: text + features */}
              <div>
                <h3 style={{
                  fontSize: '32px', fontWeight: 800,
                  letterSpacing: '-0.6px', lineHeight: 1.2,
                  marginBottom: '14px',
                }}>
                  From PDF to digital menu in 2 minutes
                </h3>
                <p style={{
                  fontSize: '16px', color: 'rgba(255,255,255,0.85)',
                  lineHeight: 1.7, marginBottom: '24px',
                }}>
                  Drop your PDF. AI extracts every section, item, and price. Add images and translations with one click. Publish.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '28px' }}>
                  <AiFeature
                    icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><polyline points="4 7 4 4 20 4 20 7" /><line x1="9" y1="20" x2="15" y2="20" /><line x1="12" y1="4" x2="12" y2="20" /></svg>}
                    text="Smart extraction of sections, items & prices"
                  />
                  <AiFeature
                    icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><polyline points="21 15 16 10 5 21" /></svg>}
                    text="Auto-find perfect food images for every dish"
                  />
                  <AiFeature
                    icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75"><circle cx="12" cy="12" r="10" /><path d="M3 12h18M12 3a13 13 0 010 18M12 3a13 13 0 000 18" /></svg>}
                    text="Translate to Arabic, English, French & more"
                  />
                </div>

                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <Link
                    to="/register"
                    className="btn btn-lg"
                    style={{
                      background: 'white', color: 'var(--text)',
                      border: 'none', textDecoration: 'none',
                    }}
                  >
                    Try AI conversion →
                  </Link>
                  <a
                    href="#features"
                    className="btn btn-lg"
                    style={{
                      background: 'rgba(255,255,255,0.1)',
                      color: 'white',
                      border: '1px solid rgba(255,255,255,0.3)',
                      backdropFilter: 'blur(10px)',
                      textDecoration: 'none',
                    }}
                  >
                    See example
                  </a>
                </div>
              </div>

              {/* Right: 5-step flow */}
              <div style={{
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '16px',
                padding: '24px',
                backdropFilter: 'blur(20px)',
              }}>
                <FlowStep
                  done
                  icon={<CheckIcon />}
                  title="PDF uploaded"
                  desc="Salt-Pepper.pdf · 3 pages"
                  time="0:02s"
                />
                <FlowStep
                  done
                  icon={<CheckIcon />}
                  title="AI extracted menu"
                  desc="3 sections · 13 items · prices identified"
                  time="0:08s"
                />
                <FlowStep
                  done
                  icon={<CheckIcon />}
                  title="Images generated"
                  desc="13 unique food photos found"
                  time="0:45s"
                />
                <FlowStep
                  done
                  icon={<CheckIcon />}
                  title="Translated to Arabic"
                  desc="All items + descriptions"
                  time="1:32s"
                />
                <FlowStep
                  pending
                  number="5"
                  title="Review & publish"
                  desc="Edit anything before going live"
                  time="1:58s"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WhatsApp Ordering — full journey */}
      <section style={{ padding: '80px 0', background: '#FAFAFB', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
        <div className="container">

          {/* Header */}
          <div style={{ textAlign: 'center', maxWidth: '640px', margin: '0 auto 40px' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              background: '#DCFCE7', color: '#166534',
              fontSize: '12px', fontWeight: 600,
              padding: '5px 12px', borderRadius: '999px', marginBottom: '14px',
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="#166534" aria-hidden="true">
                <path d="M20.52 3.48A11.78 11.78 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.17 1.6 6L0 24l6.18-1.62A11.93 11.93 0 0012 24c6.63 0 12-5.37 12-12 0-3.2-1.25-6.21-3.48-8.52zM12 21.82c-1.81 0-3.59-.49-5.14-1.42l-.37-.22-3.66.96.98-3.57-.24-.37A9.79 9.79 0 012.18 12C2.18 6.6 6.6 2.18 12 2.18c2.62 0 5.08 1.02 6.93 2.87a9.74 9.74 0 012.87 6.93c0 5.4-4.42 9.84-9.8 9.84z"/>
              </svg>
              New ordering channel
            </div>
            <h2 className="mobile-smaller" style={{
              fontSize: 'clamp(28px, 4vw, 38px)', fontWeight: 800,
              letterSpacing: '-0.5px', lineHeight: 1.15, marginBottom: '10px',
            }}>
              Take orders via{' '}
              <span style={{ color: '#25D366' }}>WhatsApp</span>
            </h2>
            <p style={{ fontSize: '15px', color: 'var(--text-2)', lineHeight: 1.6, margin: 0 }}>
              Customers browse your menu, send a pre-filled WhatsApp message, and you manage every order from your dashboard.
            </p>
          </div>

          {/* 3-step flow */}
          <div className="whatsapp-flow-grid" style={{
            display: 'grid',
            gridTemplateColumns: '1fr auto 1fr auto 1fr',
            gap: '12px',
            alignItems: 'center',
            justifyItems: 'center',
            maxWidth: '920px',
            margin: '0 auto',
          }}>

            {/* Step 1 — Customer browses */}
            <WhatsAppStepCard
              label="Step 1"
              title="Customer browses"
              accent="#7C3AED"
              phone={<PhoneMenu />}
            />

            <FlowArrow />

            {/* Step 2 — Sends on WhatsApp */}
            <WhatsAppStepCard
              label="Step 2"
              title="Sends on WhatsApp"
              accent="#25D366"
              phone={<PhoneWhatsApp />}
            />

            <FlowArrow />

            {/* Step 3 — Restaurant manages */}
            <WhatsAppStepCard
              label="Step 3"
              title="You manage it"
              accent="#7C3AED"
              phone={<DashboardCard />}
            />
          </div>

          {/* CTAs */}
          <div className="whatsapp-flow-buttons" style={{
            display: 'flex', justifyContent: 'center', gap: '10px',
            marginTop: '36px', flexWrap: 'wrap',
          }}>
            <Link to="/register" className="btn btn-primary btn-lg">Start free</Link>
            <a href="#features" className="btn btn-lg">Learn more</a>
          </div>
        </div>
      </section>

      {/* Features Grid */}
      <section id="features" style={{ padding: '80px 0', background: 'var(--bg)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              fontSize: '13px', fontWeight: 700, color: 'var(--primary)',
              textTransform: 'uppercase', letterSpacing: '1px',
              marginBottom: '12px',
            }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
              </svg>
              Everything you need
            </div>
            <h2 style={{
              fontSize: '42px', fontWeight: 800,
              letterSpacing: '-1px', lineHeight: 1.15,
              marginBottom: '12px',
              maxWidth: '700px', margin: '0 auto 12px',
            }}>
              All the tools to grow your restaurant
            </h2>
            <p style={{
              fontSize: '17px', color: 'var(--text-2)',
              maxWidth: '580px', margin: '0 auto', lineHeight: 1.6,
            }}>
              More than just a digital menu — a complete platform for modern restaurants.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
            gap: '20px',
            maxWidth: '1100px', margin: '0 auto',
          }}>
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /><line x1="14" y1="14" x2="14" y2="18" /><line x1="14" y1="18" x2="18" y2="18" /><line x1="18" y1="18" x2="18" y2="14" /><line x1="18" y1="14" x2="21" y2="14" /><line x1="14" y1="21" x2="21" y2="21" /></svg>}
              title="Smart QR codes"
              desc="Customizable QR codes you can print and place on tables, drive-thru, or anywhere customers scan."
            />
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="20" x2="12" y2="10" /><line x1="18" y1="20" x2="18" y2="4" /><line x1="6" y1="20" x2="6" y2="16" /></svg>}
              title="Real-time analytics"
              desc="Track peak hours, most-viewed dishes, and customer behavior. Make data-driven decisions."
            />
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" /><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" /></svg>}
              title="Online ordering"
              desc="Accept dine-in, takeaway, and delivery orders. Built-in cart and checkout flow."
            />
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a13 13 0 010 18M12 3a13 13 0 000 18" /></svg>}
              title="Multi-language"
              desc="Reach more customers with menus in Arabic, English, French, and any language you need."
            />
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" /></svg>}
              title="Team accounts"
              desc="Add managers, waiters, and kitchen staff with custom permissions for each role."
            />
            <FeatureCard
              icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>}
              title="Newsletter signup"
              desc="Build your customer list. Send promotions and updates directly from the platform."
            />
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" style={{ padding: '80px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              fontSize: '13px', fontWeight: 700, color: 'var(--primary)',
              textTransform: 'uppercase', letterSpacing: '1px',
              marginBottom: '12px',
            }}>
              Pricing
            </div>
            <h2 style={{
              fontSize: '42px', fontWeight: 800,
              letterSpacing: '-1px', lineHeight: 1.15,
              marginBottom: '12px',
              maxWidth: '700px', margin: '0 auto 12px',
            }}>
              Simple, transparent pricing
            </h2>
            <p style={{
              fontSize: '17px', color: 'var(--text-2)',
              maxWidth: '580px', margin: '0 auto', lineHeight: 1.6,
            }}>
              Start free. Upgrade when you need more. Cancel anytime.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))',
            gap: '20px',
            maxWidth: '1100px', margin: '0 auto',
            alignItems: 'stretch',
          }}>
            <PricingCard
              name="Free"
              price="$0"
              period="forever"
              billing="No credit card required"
              ctaLabel="Start free"
              features={[
                { yes: true, text: '1 menu' },
                { yes: true, text: 'Up to 10 sections' },
                { yes: true, text: 'Up to 100 items' },
                { yes: true, text: 'QR code generator' },
                { yes: false, text: 'AI features' },
                { yes: false, text: 'Online ordering' },
              ]}
            />

            <PricingCard
              name="Standard"
              price="$6.99"
              period="/month"
              billing={<>or $75/year · <span style={{ color: 'var(--success)', fontWeight: 600 }}>Save $8</span></>}
              ctaLabel="Start 30-day trial"
              features={[
                { yes: true, text: 'Up to 4 menus', bold: true },
                { yes: true, text: 'Unlimited sections & items' },
                { yes: true, text: 'No ads' },
                { yes: true, text: 'Visitor analytics' },
                { yes: true, text: 'Newsletter signup' },
                { yes: false, text: 'AI features' },
              ]}
            />

            <PricingCard
              name="PRO"
              price="$19"
              period="/month"
              billing={<>or $159/year · <span style={{ color: 'var(--success)', fontWeight: 600 }}>Save 30%</span></>}
              ctaLabel="Start 30-day trial"
              featured
              features={[
                { yes: true, text: 'Unlimited menus', bold: true },
                { yes: true, text: 'Everything in Standard' },
                { yes: true, sparkle: true, text: 'AI PDF conversion (5/mo)', bold: true },
                { yes: true, sparkle: true, text: 'AI image generation (100/mo)', bold: true },
                { yes: true, sparkle: true, text: 'AI translation (200/mo)', bold: true },
                { yes: true, text: 'Online ordering & team accounts' },
              ]}
            />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" style={{ padding: '80px 0', background: 'var(--bg)' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <span style={{
              fontSize: '12px', fontWeight: 700, color: 'var(--primary)',
              textTransform: 'uppercase', letterSpacing: '1px',
              padding: '6px 14px', borderRadius: '999px',
              background: 'var(--primary-50)',
              display: 'inline-block', marginBottom: '14px',
            }}>FAQ</span>
            <h2 style={{
              fontSize: 'clamp(28px, 4vw, 38px)', fontWeight: 800,
              letterSpacing: '-0.5px', marginBottom: '8px',
            }}>Frequently asked questions</h2>
            <p style={{ fontSize: '15px', color: 'var(--text-2)' }}>
              Everything you need to know before getting started
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <FaqItem question="What is a digital menu?">
              A digital menu is a restaurant menu your guests open on their phone or tablet
              by scanning a QR code on the table. No app to install — just point the camera
              and tap. You can update prices, add new dishes, or change photos any time without
              reprinting.
            </FaqItem>

            <FaqItem question="What's the difference between PDF and Digital menu formats?">
              <strong>PDF menu:</strong> upload your existing PDF and customers see it as
              high-quality images on their phone. Best if you already have a designed menu.<br/>
              <strong>Digital menu:</strong> build sections and items inside Almenu — with prices,
              photos, descriptions, multi-language support, and online ordering. Much more
              powerful, especially when paired with our AI tools.
            </FaqItem>

            <FaqItem question="Can I share my menu link on Instagram or my website?">
              Yes. Every menu has a permanent public link (like <code>almenu.io/m/yourcafe</code>)
              that you can share anywhere — Instagram bio, Facebook, Google Business profile,
              your website, WhatsApp status. The QR code points to the same URL.
            </FaqItem>

            <FaqItem question="How much does it cost?">
              Almenu is free to use with light ads on your menu. Subscribe to <strong>Standard</strong> ($7/month
              or $75/year) for ad-free menus, advanced analytics, and unlimited menus. Or go
              <strong> PRO</strong> ($19/month or $205/year) to unlock AI features — automatic menu extraction
              from a PDF or photos, AI-generated dish images, and priority support.
            </FaqItem>

            <FaqItem question="Is there a free trial?">
              Every new account gets <strong>15 days of PRO free</strong>, automatically — no credit card
              required, no obligation. You can use AI image generation, AI menu extraction,
              and every paid feature during the trial. After 15 days your account moves to
              the Free plan; you can subscribe any time to unlock the paid features again.
              Your menus and content stay safe regardless.
            </FaqItem>

            <FaqItem question="What kind of online ordering does Almenu support?">
              You can enable any combination of <strong>Dine-in</strong> (table number), <strong>Takeaway</strong>,
              <strong> Delivery</strong>, or <strong>WhatsApp</strong> — where the customer's order opens directly in your
              WhatsApp with a pre-filled message. Manage orders from your dashboard, get
              push notifications when new ones arrive, and print kitchen tickets.
            </FaqItem>

            <FaqItem question="Can I use Almenu in Arabic?">
              Yes. The platform fully supports Arabic and bilingual menus. Add an English
              and Arabic version of every section and item; the public menu shows a language
              toggle for your customers. AI features (like menu extraction from a PDF) work
              equally well on Arabic content.
            </FaqItem>

            <FaqItem question="What happens if I cancel my subscription?">
              Your menus stay live and customers can still scan them — no data is lost.
              Premium features simply pause until you renew. Almenu uses one-time payments,
              not auto-renewing subscriptions, so you decide when to pay again.
            </FaqItem>
          </div>

          <div style={{
            marginTop: '40px', textAlign: 'center', fontSize: '14px',
            color: 'var(--text-2)',
          }}>
            Still have questions? <a href="mailto:support@almenu.io" style={{
              color: 'var(--primary)', fontWeight: 600,
            }}>Get in touch</a>.
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section style={{
        padding: '80px 0',
        background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 50%, #4C1D95 100%)',
        color: 'white',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}>
        {/* Decorative glows */}
        <div style={{
          position: 'absolute', inset: 0,
          background: `
            radial-gradient(circle at 20% 50%, rgba(167, 139, 250, 0.3) 0%, transparent 50%),
            radial-gradient(circle at 80% 50%, rgba(168, 85, 247, 0.2) 0%, transparent 50%)
          `,
          pointerEvents: 'none',
        }} />

        <div className="container" style={{ position: 'relative' }}>
          <h2 style={{
            fontSize: '42px', fontWeight: 800,
            letterSpacing: '-1px', lineHeight: 1.15,
            marginBottom: '14px',
          }}>
            Ready to upgrade your menu?
          </h2>
          <p style={{
            fontSize: '17px', color: 'rgba(255,255,255,0.9)',
            maxWidth: '540px', margin: '0 auto 32px',
            lineHeight: 1.6,
          }}>
            Join 6,900+ restaurants using Almenu. Set up in 5 minutes — no credit card required.
          </p>
          <div style={{
            display: 'flex', gap: '12px',
            justifyContent: 'center', flexWrap: 'wrap',
          }}>
            <Link
              to="/register"
              className="btn btn-lg"
              style={{
                background: 'white', color: 'var(--text)',
                border: 'none', textDecoration: 'none',
                padding: '14px 28px', fontSize: '15px', fontWeight: 700,
              }}
            >
              Start free →
            </Link>
            <a
              href="mailto:hello@almenu.io"
              className="btn btn-lg"
              style={{
                background: 'rgba(255,255,255,0.1)',
                color: 'white',
                border: '1px solid rgba(255,255,255,0.3)',
                backdropFilter: 'blur(10px)',
                textDecoration: 'none',
                padding: '14px 28px', fontSize: '15px',
              }}
            >
              Talk to sales
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{
        padding: '48px 0 32px',
        background: 'white',
        borderTop: '1px solid var(--border)',
      }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
            gap: '40px',
            marginBottom: '32px',
          }}>
            {/* Brand */}
            <div style={{ maxWidth: '300px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                <span style={{
                  width: '32px', height: '32px',
                  background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)',
                  borderRadius: '9px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'white', fontSize: '16px', fontWeight: 700,
                }}>a</span>
                <span style={{
                  fontSize: '22px', fontWeight: 800, color: 'var(--primary)',
                  letterSpacing: '-0.6px',
                }}>almenu</span>
              </div>
              <p style={{
                fontSize: '13px', color: 'var(--text-2)',
                lineHeight: 1.6,
              }}>
                The all-in-one digital menu platform for modern restaurants. Trusted by 6,900+ businesses in 141 countries.
              </p>
            </div>

            {/* Product */}
            <FooterCol
              title="Product"
              links={[
                { label: 'How it works', href: '/how-to' },
                { label: 'Features', href: '/#features' },
                { label: 'Pricing', href: '/#pricing' },
                { label: 'FAQ', href: '/#faq' },
                { label: 'AI features', href: '/#features' },
              ]}
            />

            {/* Company */}
            <FooterCol
              title="Company"
              links={[
                { label: 'About', href: '#' },
                { label: 'Blog', href: 'https://blog.almenu.io/' },
                { label: 'Contact', href: 'mailto:hello@almenu.io' },
                { label: 'Affiliate program', href: '#' },
              ]}
            />

            {/* Legal */}
            <FooterCol
              title="Legal"
              links={[
                { label: 'Privacy policy', href: '/privacy' },
                { label: 'Terms of service', href: '/terms' },
                { label: 'Refund policy', href: '/refund' },
                { label: 'Subscription', href: '/subscription' },
              ]}
            />
          </div>

          {/* Bottom bar */}
          <div style={{
            borderTop: '1px solid var(--border)',
            paddingTop: '24px',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            fontSize: '12px', color: 'var(--text-3)',
            flexWrap: 'wrap', gap: '12px',
          }}>
            <div>© {new Date().getFullYear()} Almenu.io · All rights reserved</div>
            <div>Made for restaurants worldwide</div>
          </div>
        </div>
      </footer>
    </div>
  );
}

// ---- WhatsApp ordering section helpers ----

function WhatsAppStepCard({ label, title, accent, phone }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
      {phone}
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '11px', fontWeight: 700, letterSpacing: '0.4px',
          textTransform: 'uppercase', color: accent,
        }}>{label}</div>
        <div style={{ fontSize: '13px', fontWeight: 600, marginTop: '2px' }}>{title}</div>
      </div>
    </div>
  );
}

function FlowArrow() {
  return (
    <svg
      className="whatsapp-flow-arrow"
      width="22" height="14" viewBox="0 0 22 14" fill="none" aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path d="M1 7h18m0 0l-6-5m6 5l-6 5" stroke="#A78BFA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function PhoneFrame({ children, screenBg = 'white' }) {
  return (
    <div style={{
      width: '200px', height: '360px',
      background: '#111827', borderRadius: '28px',
      padding: '6px', boxSizing: 'border-box',
    }}>
      <div style={{
        background: screenBg,
        height: '100%', borderRadius: '22px',
        overflow: 'hidden',
        display: 'flex', flexDirection: 'column',
      }}>{children}</div>
    </div>
  );
}

function PhoneMenu() {
  return (
    <PhoneFrame>
      <div style={{ background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', padding: '10px 12px', color: 'white' }}>
        <div style={{ fontSize: '12px', fontWeight: 700 }}>Cafe Atlas</div>
        <div style={{ fontSize: '9px', opacity: 0.85 }}>Open · 4.8★</div>
      </div>
      <div style={{ background: '#F8FAFC', padding: '6px 12px', display: 'flex', gap: '4px', overflow: 'hidden' }}>
        <span style={{ background: '#7C3AED', color: 'white', fontSize: '9px', padding: '3px 7px', borderRadius: '999px', fontWeight: 600 }}>Drinks</span>
        <span style={{ background: 'white', color: '#6B7280', fontSize: '9px', padding: '3px 7px', borderRadius: '999px', border: '0.5px solid rgba(0,0,0,0.08)' }}>Desserts</span>
        <span style={{ background: 'white', color: '#6B7280', fontSize: '9px', padding: '3px 7px', borderRadius: '999px', border: '0.5px solid rgba(0,0,0,0.08)' }}>Mains</span>
      </div>
      <div style={{ flex: 1, padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '6px', background: '#F5F3FF', border: '0.5px solid #DDD6FE', borderRadius: '8px' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '6px', background: '#7C3AED', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '10px', fontWeight: 600 }}>Cappuccino</div>
            <div style={{ fontSize: '9px', color: '#6B7280' }}>$3.50</div>
          </div>
          <div style={{ background: '#7C3AED', color: 'white', fontSize: '10px', padding: '2px 8px', borderRadius: '999px', fontWeight: 700 }}>2</div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '6px' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '6px', background: '#FCD34D', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '10px', fontWeight: 600 }}>Cheesecake</div>
            <div style={{ fontSize: '9px', color: '#6B7280' }}>$5.50</div>
          </div>
          <div style={{ fontSize: '14px', color: '#7C3AED', fontWeight: 700 }}>+</div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', padding: '6px' }}>
          <div style={{ width: '32px', height: '32px', borderRadius: '6px', background: '#FB923C', flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: '10px', fontWeight: 600 }}>Latte</div>
            <div style={{ fontSize: '9px', color: '#6B7280' }}>$4.00</div>
          </div>
          <div style={{ fontSize: '14px', color: '#7C3AED', fontWeight: 700 }}>+</div>
        </div>
      </div>
      <div style={{ padding: '8px 10px', borderTop: '0.5px solid rgba(0,0,0,0.06)' }}>
        <div style={{ background: '#25D366', color: 'white', padding: '6px', borderRadius: '6px', fontSize: '10px', fontWeight: 600, textAlign: 'center' }}>
          Order on WhatsApp · $7.00
        </div>
      </div>
    </PhoneFrame>
  );
}

function PhoneWhatsApp() {
  return (
    <PhoneFrame screenBg="#ECE5DD">
      <div style={{ background: '#075E54', padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '8px', color: 'white' }}>
        <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700 }}>CA</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '11px', fontWeight: 600 }}>Cafe Atlas</div>
          <div style={{ fontSize: '9px', opacity: 0.75 }}>online</div>
        </div>
      </div>
      <div style={{ flex: 1, padding: '12px 10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <div style={{ alignSelf: 'flex-end', maxWidth: '88%', background: '#DCF8C6', padding: '7px 9px', borderRadius: '8px 0 8px 8px' }}>
          <div style={{ fontSize: '9px', color: '#075E54', fontWeight: 700, marginBottom: '3px' }}>New order · Table 5</div>
          <div style={{ fontSize: '10px', color: '#1F2937', lineHeight: 1.4 }}>
            <div>2× Cappuccino — $7.00</div>
            <div>1× Cheesecake — $5.50</div>
            <div style={{ borderTop: '0.5px solid rgba(0,0,0,0.1)', marginTop: '3px', paddingTop: '3px', fontWeight: 700 }}>Total: $12.50</div>
          </div>
          <div style={{ fontSize: '8px', color: '#6B7280', textAlign: 'right', marginTop: '3px' }}>12:34 ✓✓</div>
        </div>
      </div>
      <div style={{ background: '#F0F0F0', padding: '6px 8px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <div style={{ flex: 1, background: 'white', height: '22px', borderRadius: '11px' }} />
        <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: '#25D366', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="10" height="10" viewBox="0 0 24 24" fill="white" aria-hidden="true"><path d="M2 21l21-9L2 3v7l15 2-15 2z" /></svg>
        </div>
      </div>
    </PhoneFrame>
  );
}

function DashboardCard() {
  return (
    <div style={{
      width: '200px', height: '360px',
      background: 'white',
      borderRadius: '14px',
      border: '0.5px solid rgba(0,0,0,0.08)',
      overflow: 'hidden',
      display: 'flex', flexDirection: 'column',
    }}>
      <div style={{ background: '#F8FAFC', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: '6px', borderBottom: '0.5px solid rgba(0,0,0,0.06)' }}>
        <div style={{ width: '18px', height: '18px', borderRadius: '5px', background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: 700 }}>a</div>
        <div style={{ fontSize: '11px', fontWeight: 700 }}>almenu</div>
        <span style={{ fontSize: '9px', color: 'var(--text-3)', marginLeft: 'auto' }}>Orders</span>
      </div>
      <div style={{ padding: '12px 10px', flex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: '10px' }}>
          <div style={{ fontSize: '12px', fontWeight: 700 }}>Live orders</div>
          <div style={{ fontSize: '9px', color: 'var(--text-3)' }}>Just now</div>
        </div>
        <div style={{
          background: 'white',
          border: '0.5px solid #DCFCE7',
          borderLeft: '3px solid #25D366',
          borderRadius: '0 8px 8px 0',
          padding: '9px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
            <span style={{ background: '#DCFCE7', color: '#166534', fontSize: '8px', fontWeight: 700, padding: '2px 6px', borderRadius: '999px', letterSpacing: '0.3px' }}>WHATSAPP</span>
            <span style={{ fontSize: '9px', color: 'var(--text-2)' }}>#1042</span>
          </div>
          <div style={{ fontSize: '10px', lineHeight: 1.5, marginBottom: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>2× Cappuccino</span><span style={{ color: 'var(--text-2)' }}>$7.00</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}><span>1× Cheesecake</span><span style={{ color: 'var(--text-2)' }}>$5.50</span></div>
            <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '0.5px solid rgba(0,0,0,0.06)', paddingTop: '3px', marginTop: '3px' }}><span style={{ fontWeight: 700 }}>Total</span><span style={{ fontWeight: 700 }}>$12.50</span></div>
          </div>
          <div style={{ display: 'flex', gap: '4px' }}>
            <button style={{ flex: 1, background: '#25D366', color: 'white', border: 'none', padding: '5px', borderRadius: '5px', fontSize: '9px', fontWeight: 700, fontFamily: 'inherit' }}>Confirm</button>
            <button style={{ flex: 1, background: 'white', color: 'var(--text-2)', border: '0.5px solid rgba(0,0,0,0.12)', padding: '5px', borderRadius: '5px', fontSize: '9px', fontWeight: 600, fontFamily: 'inherit' }}>View</button>
          </div>
        </div>
        <div style={{
          background: 'white',
          border: '0.5px solid rgba(0,0,0,0.08)',
          borderRadius: '8px', padding: '8px', marginTop: '8px', opacity: 0.55,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '3px' }}>
            <span style={{ background: '#FEF3C7', color: '#B45309', fontSize: '8px', fontWeight: 700, padding: '2px 6px', borderRadius: '999px' }}>DINE-IN</span>
            <span style={{ fontSize: '9px', color: 'var(--text-2)' }}>#1041</span>
          </div>
          <div style={{ fontSize: '9px', color: 'var(--text-2)' }}>3 items · $19.50</div>
        </div>
      </div>
    </div>
  );
}

// Collapsible FAQ row — uses a native <details> element for free open/close
// state without any extra JS. The summary becomes the clickable question.
function FaqItem({ question, children }) {
  return (
    <details style={{
      background: 'white',
      border: '1px solid var(--border)',
      borderRadius: '12px',
      padding: '0',
      overflow: 'hidden',
    }}>
      <summary style={{
        cursor: 'pointer',
        listStyle: 'none',
        padding: '18px 20px',
        fontSize: '15px',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '12px',
      }}>
        <span style={{ flex: 1 }}>{question}</span>
        <span style={{
          flexShrink: 0,
          color: 'var(--primary)',
          fontSize: '20px',
          fontWeight: 400,
          transition: 'transform 0.2s',
        }}>+</span>
      </summary>
      <div style={{
        padding: '0 20px 18px',
        fontSize: '14px',
        lineHeight: 1.7,
        color: 'var(--text-2)',
      }}>
        {children}
      </div>
      <style>{`
        details[open] summary span:last-child { transform: rotate(45deg); }
        details summary::-webkit-details-marker { display: none; }
      `}</style>
    </details>
  );
}

function FooterCol({ title, links }) {
  const linkStyle = {
    fontSize: '13px', color: 'var(--text-2)',
    textDecoration: 'none',
    transition: 'color 0.15s',
  };
  const onEnter = e => { e.currentTarget.style.color = 'var(--primary)'; };
  const onLeave = e => { e.currentTarget.style.color = 'var(--text-2)'; };
  return (
    <div>
      <h5 style={{
        fontSize: '13px', fontWeight: 700,
        textTransform: 'uppercase', letterSpacing: '1px',
        color: 'var(--text-3)', marginBottom: '14px',
      }}>{title}</h5>
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {links.map(link => {
          // Use react-router Link for internal route paths (start with "/" but
          // are not protocol-prefixed like "//cdn..." or anchor-only "/#x").
          const isInternalRoute = typeof link.href === 'string'
            && link.href.startsWith('/')
            && !link.href.startsWith('//')
            && !link.href.startsWith('/#');
          return (
            <li key={link.label} style={{ padding: '4px 0' }}>
              {isInternalRoute ? (
                <Link to={link.href} style={linkStyle} onMouseEnter={onEnter} onMouseLeave={onLeave}>
                  {link.label}
                </Link>
              ) : (
                <a
                  href={link.href}
                  style={linkStyle}
                  onMouseEnter={onEnter}
                  onMouseLeave={onLeave}
                  {...(link.href?.startsWith('http')
                    ? { target: '_blank', rel: 'noreferrer' }
                    : {})}
                >
                  {link.label}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

function SocialLink({ icon, href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      style={{
        width: '34px', height: '34px',
        borderRadius: '8px',
        background: 'var(--bg)',
        color: 'var(--text-2)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        textDecoration: 'none',
        transition: 'all 0.15s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = 'var(--primary)';
        e.currentTarget.style.color = 'white';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'var(--bg)';
        e.currentTarget.style.color = 'var(--text-2)';
      }}
    >{icon}</a>
  );
}

function TwitterIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h3l-7.5 8.5L22 22h-6.5l-5-6.5L4.5 22H2l8-9-7.5-11h6.5l4.5 6z" />
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
    </svg>
  );
}

function LinkedinIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-4 0v7h-4v-7a6 6 0 016-6z" />
      <rect x="2" y="9" width="4" height="12" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  );
}

function PricingCard({ name, price, period, billing, ctaLabel, features, featured }) {
  return (
    <div
      className="card"
      style={{
        padding: '32px 28px',
        position: 'relative',
        border: featured ? '2px solid var(--primary)' : '1px solid var(--border)',
        background: featured ? 'linear-gradient(180deg, white 0%, #FAFAFB 100%)' : 'white',
        boxShadow: featured ? '0 20px 60px rgba(124, 58, 237, 0.1)' : 'none',
        transform: featured ? 'scale(1.02)' : 'none',
        display: 'flex', flexDirection: 'column',
      }}
    >
      {featured && (
        <div style={{
          position: 'absolute',
          top: '-12px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)',
          color: 'white',
          fontSize: '11px',
          fontWeight: 700,
          padding: '5px 14px',
          borderRadius: '999px',
          letterSpacing: '0.5px',
          whiteSpace: 'nowrap',
          boxShadow: '0 4px 12px rgba(124, 58, 237, 0.3)',
        }}>MOST POPULAR</div>
      )}

      <div style={{
        fontSize: '13px', fontWeight: 700, color: 'var(--text-2)',
        textTransform: 'uppercase', letterSpacing: '1px',
        marginBottom: '12px',
      }}>{name}</div>

      <div style={{
        display: 'flex', alignItems: 'baseline', gap: '4px',
        marginBottom: '6px',
      }}>
        <span style={{ fontSize: '48px', fontWeight: 800, letterSpacing: '-1.5px' }}>{price}</span>
        <span style={{ fontSize: '14px', color: 'var(--text-2)', fontWeight: 500 }}>{period}</span>
      </div>

      <div style={{ fontSize: '12px', color: 'var(--text-3)', marginBottom: '24px' }}>
        {billing}
      </div>

      <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 24px 0', flex: 1 }}>
        {features.map((f, i) => (
          <li
            key={i}
            style={{
              padding: '8px 0',
              display: 'flex', alignItems: 'flex-start', gap: '10px',
              fontSize: '13px', color: 'var(--text-2)',
              borderBottom: i < features.length - 1 ? '1px solid var(--border)' : 'none',
            }}
          >
            <svg
              width="16" height="16" viewBox="0 0 24 24"
              fill="none" stroke={f.yes ? (f.sparkle ? 'var(--primary)' : 'var(--success)') : 'var(--text-3)'}
              strokeWidth={f.yes ? '2.5' : '2'}
              strokeLinecap="round" strokeLinejoin="round"
              style={{ flexShrink: 0, marginTop: '2px' }}
            >
              {f.yes ? (
                f.sparkle ? (
                  <>
                    <path d="M12 3l1.91 5.26L19 10l-5.09 1.74L12 17l-1.91-5.26L5 10l5.09-1.74L12 3z" />
                    <path d="M19 17l.95 2.63L22 20l-2.05.37L19 23l-.95-2.63L16 20l2.05-.37L19 17z" />
                  </>
                ) : (
                  <polyline points="20 6 9 17 4 12" />
                )
              ) : (
                <>
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </>
              )}
            </svg>
            <span style={f.bold ? { color: 'var(--text)', fontWeight: 600 } : {}}>{f.text}</span>
          </li>
        ))}
      </ul>

      <Link
        to="/register"
        style={{
          display: 'block',
          width: '100%',
          padding: '12px',
          borderRadius: '10px',
          fontSize: '14px',
          fontWeight: 600,
          textAlign: 'center',
          textDecoration: 'none',
          background: featured
            ? 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)'
            : 'white',
          color: featured ? 'white' : 'var(--text)',
          border: featured ? 'none' : '1px solid var(--border)',
          boxShadow: featured ? '0 4px 14px rgba(124, 58, 237, 0.3)' : 'none',
        }}
      >{ctaLabel}</Link>
    </div>
  );
}

function AiFeature({ icon, text }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px' }}>
      <div style={{
        width: '28px', height: '28px',
        background: 'rgba(255,255,255,0.15)',
        borderRadius: '7px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flexShrink: 0,
        color: 'white',
      }}>{icon}</div>
      <span>{text}</span>
    </div>
  );
}

function FlowStep({ done, pending, icon, number, title, desc, time }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '14px',
      background: done ? 'rgba(34, 197, 94, 0.15)' : 'rgba(255,255,255,0.06)',
      border: `1px solid ${done ? 'rgba(34, 197, 94, 0.4)' : 'rgba(255,255,255,0.1)'}`,
      borderRadius: '12px',
      padding: '14px 16px',
      marginBottom: '10px',
    }}>
      <div style={{
        width: '32px', height: '32px',
        background: done ? '#16A34A' : 'rgba(255,255,255,0.15)',
        borderRadius: '8px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontWeight: 700, fontSize: '14px',
        flexShrink: 0,
        color: 'white',
      }}>{icon || number}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '2px' }}>{title}</div>
        <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)' }}>{desc}</div>
      </div>
      <div style={{
        fontSize: '11px',
        color: 'rgba(255,255,255,0.6)',
        fontWeight: 600,
        flexShrink: 0,
      }}>{time}</div>
    </div>
  );
}

function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function FeatureCard({ icon, title, desc }) {
  return (
    <div
      className="card"
      style={{
        padding: '24px',
        transition: 'all 0.2s',
        cursor: 'default',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = 'var(--primary)';
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 8px 24px rgba(124, 58, 237, 0.08)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = 'var(--border)';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{
        width: '48px', height: '48px',
        background: 'var(--primary-50)',
        color: 'var(--primary)',
        borderRadius: '12px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '16px',
      }}>{icon}</div>
      <h3 style={{
        fontSize: '18px', fontWeight: 700,
        marginBottom: '8px', letterSpacing: '-0.3px',
      }}>{title}</h3>
      <p style={{
        fontSize: '14px', color: 'var(--text-2)',
        lineHeight: 1.6,
      }}>{desc}</p>
    </div>
  );
}
